module.exports = __webpack_public_path__ + "static/2b-d012c934c1f5a8ac4a5e4436dec32703.jpg";